import React from 'react';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import HeaderContador from './HeaderContador';
import Roles from '../../config/roles';
import { TraspasosService, TRASPASO_ESTADO } from '../../features/traspasos';

// Referencia estable a nivel de módulo para no reiniciar el intervalo en cada render
const cargarTraspasosPendientes = async () => {
    // Endpoint de conteo del API, con el mismo rango que el listado del feature: últimos 30 días
    const hasta = new Date();
    const desde = new Date();
    desde.setDate(desde.getDate() - 30);

    return TraspasosService.count({
        estado: TRASPASO_ESTADO.PENDIENTE,
        fechaDesde: desde.toISOString().slice(0, 10),
        fechaHasta: hasta.toISOString().slice(0, 10),
    });
};

/**
 * Icono del header con el número de traspasos pendientes; navega a /traspasos
 */
export default function HeaderTraspasos({ compacto = false }) {
    return (
        <HeaderContador
            icon={SyncAltIcon}
            ruta="/traspasos"
            titulo="traspasos pendientes"
            roles={[Roles.ADMIN.role, Roles.REPONEDOR.role]}
            cargarContador={cargarTraspasosPendientes}
            color="warning"
            compacto={compacto}
            triggerKey="traspasos"
        />
    );
}
